import { createLightTheme } from "../../utils/createLightTheme.js";
import { brandTeams } from "../../global/brandColors.js";
import { fontFamilies } from "../../alias/teamsFontFamilies.js";
export const teamsLightTheme = {
    ...createLightTheme(brandTeams),
    ...fontFamilies
};
